import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Globe2, Users, Radio, Send, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

export default function LiveTrafficBadge({ compact = false }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        let live = true;
        async function load() {
            try {
                const r = await api.get("/public/stats");
                if (live) setData(r.data);
            } catch (_e) { /* silent */ }
        }
        load();
        const t = setInterval(load, 20000);
        return () => { live = false; clearInterval(t); };
    }, []);

    if (!data) return null;

    if (compact) {
        return (
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/15 border border-emerald-500/30 text-emerald-300 text-xs font-mono" data-testid="live-badge-compact">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                {data.visitors_live > 0 ? `${data.visitors_live} en ligne` : "boxe-b2b.com actif"}
            </div>
        );
    }

    const items = [
        { icon: Radio, value: data.visitors_live, label: "en direct", tone: "emerald", pulse: data.visitors_live > 0 },
        { icon: Users, value: data.visitors_7d.toLocaleString("fr-FR"), label: "visiteurs / 7j", tone: "cyan" },
        { icon: Globe2, value: data.countries_reached, label: "pays touchés", tone: "indigo" },
        { icon: TrendingUp, value: data.leads_processed.toLocaleString("fr-FR"), label: "leads traités", tone: "violet" },
        { icon: Send, value: data.campaigns_launched, label: "campagnes lancées", tone: "cyan" },
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="rounded-2xl p-5 bg-brand-surface/60 border border-white/10 backdrop-blur-sm"
            data-testid="live-traffic-widget"
        >
            <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-brand-cyan mb-3 flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> LIVE — activité BOXEB2B en temps réel
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                {items.map(({ icon: Icon, value, label, tone, pulse }) => (
                    <div key={label} className="text-left">
                        <div className="flex items-center gap-1.5 mb-1">
                            <Icon size={11} className={`text-brand-${tone === "emerald" ? "cyan" : tone} ${pulse ? "animate-pulse" : ""}`} />
                            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{label}</div>
                        </div>
                        <div className="font-display font-black text-xl tracking-tighter">{value}</div>
                    </div>
                ))}
            </div>
            <div className="mt-3 text-[10px] text-zinc-600 font-mono">
                Aucun compteur gonflé. Rafraîchit toutes les 20 s.
            </div>
        </motion.div>
    );
}
